// src/api/business/manageApi.js
import { getRequest, apiRequest, ApiError } from "../apiConfig";

function unwrapList(payload) {
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload?.data)) return payload.data;
  if (Array.isArray(payload?.businesses)) return payload.businesses;
  if (Array.isArray(payload?.results)) return payload.results;
  return [];
}

function mapBusiness(b) {
  return {
    _id: b._id,
    id: b._id,
    businessName: b.business_name,
    branchName: b.branch_name,
    country: b.country,
    state: b.state,
    city: b.city,
    businessEntity: b.business_entity,
    registrationNumber: b.registration_number,
    businessCategory: b.business_category,
    contactPersonName: b.contact_person_name,
    email: b.contact_email,
    mobileNumber: b.contact_mobile,
    totalEmployees: b.total_employees,
    status: b.status,
    blacklisted: b.blacklisted,
    blacklistReason: b.blacklist_reason,
    createdAt: b.created_at,
    updatedAt: b.updated_at,
    isBlacklisted: b.blacklisted,
  };
}

// ✅ main list
export async function getApprovedBusinesses(filters = {}) {
  const payload = await getRequest("/admin/businesses", filters);
  return unwrapList(payload).map(mapBusiness);
}

// ✅ NO /admin/blacklist/businesses (doesn't exist)
// ✅ filter from /admin/businesses
export async function getBlacklistedBusinesses() {
  const list = await getApprovedBusinesses();
  return list.filter((b) => b.blacklisted);
}

// ✅ Some backends use PUT/PATCH instead of POST.
// We try PUT → PATCH → POST only for 404/405.
async function callWithMethodFallback(endpoint, data, methods = ["PUT", "PATCH", "POST"]) {
  let lastErr = null;
  for (const method of methods) {
    try {
      return await apiRequest(endpoint, { method, data });
    } catch (e) {
      lastErr = e;
      const status = e instanceof ApiError ? e.status : e?.status;
      if (status !== 404 && status !== 405) throw e; // real error, stop
    }
  }
  throw lastErr;
}

// ✅ blacklist / unblacklist (method safe)
export async function blacklistBusiness(businessId, reason = "") {
  return await callWithMethodFallback(`/admin/businesses/${businessId}/blacklist`, { reason });
}

export async function removeFromBlacklist(businessId) {
  // usually DELETE, but some backends use PUT/PATCH
  try {
    return await apiRequest(`/admin/businesses/${businessId}/unblacklist`, { method: "DELETE" });
  } catch (e) {
    const status = e instanceof ApiError ? e.status : e?.status;
    if (status === 404 || status === 405) {
      return await callWithMethodFallback(`/admin/businesses/${businessId}/unblacklist`, {});
    }
    throw e;
  }
}
